import React from 'react';
import BrandMark from './BrandMark';

interface AppLoaderProps {
  title: string;
  subtitle: string;
  fullscreen?: boolean;
}

const AppLoader: React.FC<AppLoaderProps> = ({
  title,
  subtitle,
  fullscreen = true
}) => {
  const buildId = typeof __APP_BUILD_ID__ === 'string' ? __APP_BUILD_ID__ : 'unknown';
  const wrapperClassName = fullscreen
    ? 'fixed inset-0 z-[120] flex min-h-[100dvh] w-full items-center justify-center overflow-hidden px-5 py-[max(1.5rem,env(safe-area-inset-top))] pb-[max(1.5rem,env(safe-area-inset-bottom))]'
    : 'relative flex min-h-[240px] w-full items-center justify-center overflow-hidden rounded-[28px] px-6';

  return (
    <div className={`${wrapperClassName} bg-background`}>
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_50%_-10%,_rgba(168,85,247,0.18),_transparent_38%),radial-gradient(circle_at_50%_120%,_rgba(34,211,238,0.12),_transparent_34%)]" />

      <div className="relative w-full max-w-sm rounded-[28px] border border-white/10 bg-card/90 p-6 text-center shadow-[0_20px_70px_rgba(168,85,247,0.12)] backdrop-blur-sm">
        <div className="flex justify-center">
          <BrandMark
            showTitle={false}
            imageClassName="h-16 w-16 rounded-[22px] border border-neon-purple/20 bg-black/30 p-2 shadow-[0_0_28px_rgba(168,85,247,0.16)]"
          />
        </div>

        <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.32em] text-neon-purple">Dopamind</p>
        <h2 className="mt-2 text-2xl font-display font-bold text-white">{title}</h2>
        <p className="mt-2 text-sm leading-relaxed text-gray-400">{subtitle}</p>

        <div className="mt-5 overflow-hidden rounded-full border border-white/10 bg-black/30">
          <div className="h-2 w-full bg-[linear-gradient(90deg,rgba(168,85,247,0.15),rgba(255,255,255,0.9),rgba(34,211,238,0.2))] animate-pulse" />
        </div>

        <div className="mt-4 flex items-center justify-center gap-2 text-[10px] uppercase tracking-[0.24em] text-gray-500">
          <span className="h-2 w-2 rounded-full bg-neon-purple animate-pulse" />
          Ajustando o campo de batalha
        </div>

        <div className="mt-3 text-[10px] uppercase tracking-[0.24em] text-gray-600">
          Build {buildId}
        </div>
      </div>
    </div>
  );
};

export default AppLoader;
